import { useEffect, useState } from 'react';
import { Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../components';
import { request, toast } from '../../../../../utils';
import { LIMIT_TYPE } from '../../../../../constants';

const MACHINE_TEST_ITEM_MAPPING_HEADER = [
  {
    header: 'Test Item Name',
    accessor: 'test_item_name',
    sx: { textTransform: 'capitalize' }
  },

  {
    header: 'Machine Item Code',
    accessor: 'machine_item_code'
  },
  {
    header: 'Action'
  }
];

export const MachineTestItemMapping = () => {
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        discount_authority: Yup.string().required('Discount Authority Is Required ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('discount_authority', selectedRecord.discount_authority);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        discount_authority: formValues.discount_authority,
        limit_type: formValues.limit_type
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Discount Authority master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Discount Authority master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Discount Authority master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Discount Authority master', { variant: 'error' });
    }
    setLoading(false);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3">
                Machine Test Item Mapping
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button variant="contained">Apply</Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>

            <Grid container spacing={1}>
              <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Machine Name</Typography>
                  <SelectTag formControlSX={{ flex: 0.8 }} placeholder="Enter Machine Name" name="machine_name" />
                </Stack>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Machine Code</Typography>
                  <TextField sx={{ flex: 0.8 }} disabled name="machine_code" />
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', minHeight: '30rem', flexDirection: 'column', gap: 0.3 }}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={serviceList}
                  columns={MACHINE_TEST_ITEM_MAPPING_HEADER}
                  size="medium"
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
